// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file terceros_lote.proto (package sextante.terceros.lote.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file terceros_lote.proto.
 */
export const file_terceros_lote: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Subconjunto de CultivoResponse: solo lo que de verdad lee un lote (id/nombre para mostrar, mas
 * lo que ClienteModulesComponent necesita para habilitar modulos). is_monitoreo_cafe se queda
 * aparte porque Café tiene su propio modulo (Broca), sin relacion con el catalogo de plagas
 * (MonitoreoPlagaEnfermedadResponse ni siquiera tiene esa bandera). Las otras 6 banderas
 * is_monitoreo_* (citricos/aguacate_hass/mango/macadamia/guanabana/papa) SALIERON: en toda la app
 * se usaban solo juntas, en un OR, para responder "¿este cultivo tiene alguna plaga asociada?" —
 * eso es exactamente cantidad_plagas > 0, calculado en servidor (COUNT sobre
 * CultivoMonitoreoPlagaEnfermedad agrupado por tipo_monitoreo_id) para no obligar al cliente a
 * tener el catalogo completo de plagas cargado solo para este cruce. tipo_monitoreo_id NO va:
 * mismo motivo que en catalogos_aplicaciones.proto (CultivoItem), sin uso en Cliente.
 *
 * @generated from message sextante.terceros.lote.v1.CultivoResumen
 */
export type CultivoResumen = Message<"sextante.terceros.lote.v1.CultivoResumen"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: bool is_monitoreo_cafe = 3;
   */
  isMonitoreoCafe: boolean;

  /**
   * Plagas del catalogo asociadas al cultivo. Mayor a 0 habilita el monitoreo de plagas.
   *
   * @generated from field: int32 cantidad_plagas = 4;
   */
  cantidadPlagas: number;
};

/**
 * Describes the message sextante.terceros.lote.v1.CultivoResumen.
 * Use `create(CultivoResumenSchema)` to create a new message.
 */
export const CultivoResumenSchema: GenMessage<CultivoResumen> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 0);

/**
 * Lote de una finca, con el resumen de ganaderia.
 *
 * @generated from message sextante.terceros.lote.v1.ClienteFincaLoteItem
 */
export type ClienteFincaLoteItem = Message<"sextante.terceros.lote.v1.ClienteFincaLoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string nombre_lote = 5;
   */
  nombreLote: string;

  /**
   * @generated from field: double area_hectareas = 6;
   */
  areaHectareas: number;

  /**
   * @generated from field: double area_cuadras = 7;
   */
  areaCuadras: number;

  /**
   * true si el lote cuenta para las hectareas productivas de la finca.
   *
   * @generated from field: bool is_area_productiva = 8;
   */
  isAreaProductiva: boolean;

  /**
   * GeoJSON Polygon
   *
   * @generated from field: string area_geografica_polygon = 9;
   */
  areaGeograficaPolygon: string;

  /**
   * @generated from field: optional sextante.terceros.lote.v1.CultivoResumen cultivo = 10;
   */
  cultivo?: CultivoResumen | undefined;

  /**
   * Animales que hay hoy en el lote.
   *
   * @generated from field: int32 ganaderia_cantidad_animales = 11;
   */
  ganaderiaCantidadAnimales: number;

  /**
   * Ultimo ingreso de animales al lote, en Unix ms.
   *
   * @generated from field: optional int64 ganaderia_ultimo_ingreso = 12;
   */
  ganaderiaUltimoIngreso?: bigint | undefined;

  /**
   * Ultima salida de animales del lote, en Unix ms.
   *
   * @generated from field: optional int64 ganaderia_ultima_salida = 13;
   */
  ganaderiaUltimaSalida?: bigint | undefined;

  /**
   * Peso promedio del ultimo pesaje, en kg.
   *
   * @generated from field: optional double ganaderia_peso_real_promedio_kg = 14;
   */
  ganaderiaPesoRealPromedioKg?: number | undefined;

  /**
   * Fecha del ultimo pesaje, en Unix ms.
   *
   * @generated from field: optional int64 ganaderia_fecha_ultimo_pesaje = 15;
   */
  ganaderiaFechaUltimoPesaje?: bigint | undefined;

  /**
   * Peso total estimado de los animales del lote, en kg.
   *
   * @generated from field: optional double ganaderia_peso_estimado_total_kg = 16;
   */
  ganaderiaPesoEstimadoTotalKg?: number | undefined;

  /**
   * Fecha de la ultima estimacion de peso, en Unix ms.
   *
   * @generated from field: optional int64 ganaderia_fecha_ultimo_peso_estimado = 17;
   */
  ganaderiaFechaUltimoPesoEstimado?: bigint | undefined;

  /**
   * Ganancia de peso diaria de todo el lote, en kg. El peso estimado crece en linea recta desde la fecha del
   * ultimo peso estimado.
   *
   * @generated from field: optional double ganaderia_ganancia_diaria_total_kg = 18;
   */
  ganaderiaGananciaDiariaTotalKg?: number | undefined;
};

/**
 * Describes the message sextante.terceros.lote.v1.ClienteFincaLoteItem.
 * Use `create(ClienteFincaLoteItemSchema)` to create a new message.
 */
export const ClienteFincaLoteItemSchema: GenMessage<ClienteFincaLoteItem> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 1);

/**
 * Pedido de los lotes de una finca.
 *
 * @generated from message sextante.terceros.lote.v1.ListLotesByFincaIdRequest
 */
export type ListLotesByFincaIdRequest = Message<"sextante.terceros.lote.v1.ListLotesByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.terceros.lote.v1.ListLotesByFincaIdRequest.
 * Use `create(ListLotesByFincaIdRequestSchema)` to create a new message.
 */
export const ListLotesByFincaIdRequestSchema: GenMessage<ListLotesByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 2);

/**
 * Lotes que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.terceros.lote.v1.ListLotesByFincaIdResponse
 */
export type ListLotesByFincaIdResponse = Message<"sextante.terceros.lote.v1.ListLotesByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem items = 1;
   */
  items: ClienteFincaLoteItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.terceros.lote.v1.ListLotesByFincaIdResponse.
 * Use `create(ListLotesByFincaIdResponseSchema)` to create a new message.
 */
export const ListLotesByFincaIdResponseSchema: GenMessage<ListLotesByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 3);

/**
 * Igual que REST (ClienteFincaLoteController.SaveAsync): solo actualizacion, solo 3 campos
 * editables por esta via (nombre, cultivo, area productiva) -geometria/area y ganaderia/monitoreo
 * se gestionan en sus propios modulos-.
 *
 * @generated from message sextante.terceros.lote.v1.GuardarLoteRequest
 */
export type GuardarLoteRequest = Message<"sextante.terceros.lote.v1.GuardarLoteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_lote = 2;
   */
  nombreLote: string;

  /**
   * @generated from field: optional string cultivo_id = 3;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: bool is_area_productiva = 4;
   */
  isAreaProductiva: boolean;
};

/**
 * Describes the message sextante.terceros.lote.v1.GuardarLoteRequest.
 * Use `create(GuardarLoteRequestSchema)` to create a new message.
 */
export const GuardarLoteRequestSchema: GenMessage<GuardarLoteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 4);

/**
 * Resultado de editar un lote (2026-10-08): el lote y las hectareas productivas de su finca. Antes solo
 * volvia el lote, y marcar o desmarcar un lote como area productiva no cambiaba las hectareas productivas
 * de la finca: quedaban mal la capacidad del dashboard de ganaderia y el "Area productiva" del menu.
 *
 * @generated from message sextante.terceros.lote.v1.GuardarLoteResponse
 */
export type GuardarLoteResponse = Message<"sextante.terceros.lote.v1.GuardarLoteResponse"> & {
  /**
   * @generated from field: sextante.terceros.lote.v1.ClienteFincaLoteItem lote = 1;
   */
  lote?: ClienteFincaLoteItem | undefined;

  /**
   * Hectareas productivas de la finca, recalculadas al guardar: suma del area de sus lotes marcados como
   * area productiva. Solo falta si la finca no existe.
   *
   * @generated from field: optional double finca_hectareas_productivas = 2;
   */
  fincaHectareasProductivas?: number | undefined;
};

/**
 * Describes the message sextante.terceros.lote.v1.GuardarLoteResponse.
 * Use `create(GuardarLoteResponseSchema)` to create a new message.
 */
export const GuardarLoteResponseSchema: GenMessage<GuardarLoteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_lote, 5);

/**
 * Lotes de finca de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de servicios.
 * Listado por finca con delta, y edicion de nombre, cultivo y area productiva: los lotes se crean en el
 * asistente de registro de finca. Requiere sesion de la app Cliente.
 * 
 * Nombres de mensaje con prefijo "ClienteFincaLote"/"Lote" en vez de genericos ("Item"/
 * "GuardarRequest"): csharp_namespace es el mismo "Api.Grpc" en todos los .proto de este proyecto
 * (no varia por package), asi que dos mensajes con el mismo nombre en protos distintos colisionan
 * como clases C# aunque vivan en packages proto diferentes -paso con LoteItem/GuardarRequest, que
 * ya existen en terceros_finca_wizard.proto-.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.terceros.lote.v1.ClienteFincaLoteService
 */
export const ClienteFincaLoteService: GenService<{
  /**
   * Lotes de una finca, por delta.
   *
   * @generated from rpc sextante.terceros.lote.v1.ClienteFincaLoteService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListLotesByFincaIdRequestSchema;
    output: typeof ListLotesByFincaIdResponseSchema;
  },
  /**
   * Edita nombre, cultivo y area productiva de un lote. No crea lotes. Devuelve el lote y las hectareas
   * productivas de la finca, recalculadas.
   *
   * @generated from rpc sextante.terceros.lote.v1.ClienteFincaLoteService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarLoteRequestSchema;
    output: typeof GuardarLoteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_terceros_lote, 0);

